import React from "react";
import { useDispatch, useSelector } from "react-redux";

import facebookIcon from "images/auth/facebook-f.svg";
import googleIcon from "images/auth/google.svg";
import microsoftIcon from "images/auth/microsoft.svg";
import yahooIcon from "images/auth/yahoo-logo.svg";
import appleIcon from "images/auth/apple-logo.svg";
import emailIcon from "images/auth/email-icon.svg";
import userIcon from "images/auth/user-icon.svg";

import SocialButton from "componentes/shared/SocialButton";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";

import { signInWithSocial } from "./actions";
import WaveLayout from "./WaveLayout";

import { useAuth0 } from "../Auth0/useAuth";

const useReduxSelector = () =>
  useSelector((state) => ({
    isLoading: state.authReducer.isLoading,
  }));

const SigninWithSocialNetworks = ({ onChangeToEmailLogin }) => {
  const dispatch = useDispatch();
  const { isLoading } = useReduxSelector();

  const { loginSocial } = useAuth0();

  return (
    <WaveLayout title={"Ingresá con tu red social"} isLoading={isLoading}>
      <SocialButton
        label={"Facebook"}
        onClick={() =>
          dispatch(signInWithSocial(() => loginSocial("facebook")))
        }
        icon={facebookIcon}
        backgroundColor={"#3e5d9e"}
        backgroundColorIcon={"#33508e"}
      />
      <div style={{ height: 10 }} />
      <SocialButton
        onClick={() =>
          dispatch(signInWithSocial(() => loginSocial("google-oauth2")))
        }
        label={"Gmail"}
        icon={googleIcon}
        backgroundColor={"#ef4837"}
        backgroundColorIcon={"#d93a2a"}
      />
      <div style={{ height: 10 }} />
      <SocialButton
        onClick={() =>
          dispatch(signInWithSocial(() => loginSocial("windowslive")))
        }
        label={"Hotmail"}
        icon={microsoftIcon}
        backgroundColor={"#484848"}
        backgroundColorIcon={"#3e3e3e"}
      />
      <div style={{ height: 10 }} />
      <SocialButton
        onClick={() => dispatch(signInWithSocial(() => loginSocial("yahoo")))}
        label={"Yahoo"}
        icon={yahooIcon}
        backgroundColor={"#842a83"}
        backgroundColorIcon={"#6f1f6e"}
      />
      <div style={{ height: 10 }} />
      <SocialButton
        onClick={() => dispatch(signInWithSocial(() => loginSocial("apple")))}
        label={"Continuar con Apple"}
        icon={appleIcon}
        backgroundColor={"#101426"}
        backgroundColorIcon={"#101426"}
      />
      <div style={{ height: 15 }} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "286px",
        }}
      >
        <Divider
          style={{
            flexGrow: 1,
            height: "1px",
            backgroundColor: "#bab5b5",
          }}
        />
        <Typography
          style={{
            margin: "0 10px",
            color: "#757575",
            fontSize: "13px",
            whiteSpace: "nowrap",
          }}
        >
          O bien a través de tu
        </Typography>
        <Divider
          style={{
            flexGrow: 1,
            height: "1px",
            backgroundColor: "#bab5b5",
          }}
        />
      </div>

      <div style={{ height: 15 }} />
      <SocialButton
        onClick={onChangeToEmailLogin}
        label={"Email corporativo"}
        icon={emailIcon}
        paddingIcon={12}
        backgroundColor={"#f8f7f9"}
        backgroundColorIcon={"#f7f5fa"}
        labelColor={"#252525"}
        textAlign={"justify"}
        marginLeftText={24}
      />
      <div style={{ height: 10 }} />
      <SocialButton
        onClick={() =>
          dispatch(
            signInWithSocial(() =>
              loginSocial("Username-Password-Authentication")
            )
          )
        }
        label={"Usuario y clave"}
        icon={userIcon}
        paddingIcon={12}
        backgroundColor={"#f8f7f9"}
        backgroundColorIcon={"#f7f5fa"}
        labelColor={"#252525"}
        textAlign={"justify"}
        marginLeftText={24}
      />
    </WaveLayout>
  );
};

export default SigninWithSocialNetworks;
